import { useContext, useEffect } from 'react';
// import "./style.css";

import { GlobalMobileContext } from "../contexts/globalMobileContext";

import Mobile_HeaderComponent from './Mobile_HeaderComponent';

import Mobile_ErrorComponent from './Mobile_ErrorComponent';

import Mobile_ProjectsListPage from './pages/Mobile_ProjectsListPage';
import Mobile_ProjectConferencesPage from './pages/Mobile_ProjectConferencesPage';
import Mobile_ConferenceMenuPage from './pages/Mobile_ConferenceMenuPage';
import Mobile_ConferenceNotesPage from './pages/Mobile_ConferenceNotesPage';
import Mobile_ConferenceTopicPage from './pages/Mobile_ConferenceTopicPage';
import Mobile_LogOutPopupComponent from './pages/Mobile_LogOutPopupComponent';
import Mobile_ConferenceEditNotesPage from './pages/Mobile_ConferenceEditNotesPage';

import { sortNotesByUpdatedAt } from '../utils/UtilitaryFunctions';

const Mobile_MainScreenComponent = () => {

    const { currentPage, setCurrentPage, currentError, projectIdParam, mobileSocketRef, setConferencesList, setCurrentProject, conferenceIdParam, currentUser,
        typeParam, setCurrentConference, setCurrentTopicsList, setCurrentNotesList, setCurrentError, logOutPopup
    } = useContext(GlobalMobileContext);

    useEffect(() => {
        if (projectIdParam) {
            mobileSocketRef.current.emit("MOBILE_GET_ALL_PROJECTS", currentUser._id, (projects) => {
                let project = projects.find(proj => proj._id === projectIdParam)

                setCurrentProject(project)

                mobileSocketRef.current.emit("MOBILE_GET_CONFERENCES_BY_PROJECT", projectIdParam, currentUser._id, (conferences) => {

                    setConferencesList(conferences)

                    let conference = conferences.find(conf => conf._id === conferenceIdParam)

                    setCurrentConference(conference)

                    if (typeParam === "notes") {
                        mobileSocketRef.current.emit("MOBILE_CONFERENCE_GET_NOTES", conferenceIdParam, currentUser._id, (callback) => {
                            if (!callback.error) {
                                let notes = sortNotesByUpdatedAt(callback.response)
                                setCurrentNotesList(notes)
                                setCurrentPage("Notes")
                            } else {
                                setCurrentError(callback.error)
                            }
                        });
                    } else {
                        mobileSocketRef.current.emit("MOBILE_CONFERENCE_GET_TOPICS", conferenceIdParam, currentUser._id, (callback) => {
                            if (!callback.error) {
                                setCurrentTopicsList(callback.response)
                                setCurrentPage("Topics")
                            } else {
                                setCurrentError(callback.error)
                            }
                        });
                    }
                });
            });

        } else {
            setCurrentPage("Projects");

        }
    }, []);

    

    return (
        <>
            <Mobile_HeaderComponent />

            <main id="main" className="main" 
                style={{backgroundColor: "#050020", height: "calc(100dvh - 40px)", display: 'flex', flexDirection: "column", marginLeft: "0px", padding: "0px", marginTop: "40px"}}>
                {currentError && <Mobile_ErrorComponent />}

                {logOutPopup && <Mobile_LogOutPopupComponent/>}

                {currentPage === "Projects" && <Mobile_ProjectsListPage />}
                {currentPage === "Conferences" && <Mobile_ProjectConferencesPage />}
                {currentPage === "Conference menu" && <Mobile_ConferenceMenuPage />}
                {currentPage === "Notes" && <Mobile_ConferenceNotesPage />}
                {currentPage === "Topics" && <Mobile_ConferenceTopicPage />}

                {currentPage === "NotesEdit" && <Mobile_ConferenceEditNotesPage/>}
            </main>
        </>
    );
}

export default Mobile_MainScreenComponent;